import axios from 'axios';
import config from '../../config';
import { apiCode, apiConfig } from '../../services';
import { filePromises } from '../admin';
import { setShowSuccess } from '../ui';

export const POSTS_LOADED = 'POSTS_LOADED';
export const POST_LOADED = 'POST_LOADED';
export const BLOG_LOADING = 'BLOG_LOADING';
export const SAVING = 'SAVING';
export const ERROR = 'ERROR';

export const postsLoaded = payload => {
    return {
        type: POSTS_LOADED,
        payload,
    };
};

export const postLoaded = payload => {
    return {
        type: POST_LOADED,
        payload,
    };
};

export const loading = payload => {
    return {
        type: BLOG_LOADING,
        payload,
    };
};

export const saving = payload => {
    return {
        type: SAVING,
        payload,
    };
};

export const error = payload => {
    return {
        type: ERROR,
        payload,
    };
};

export const clearError = () => {
    return {
        type: ERROR,
        payload: false,
    };
};

export const update = (entity, callback) => {
    return (dispatch, getState) => {
        dispatch(saving(true));
        dispatch(error(false));

        const { guid } = getState().user.user;
        return Promise.all(filePromises(entity, ['blog_Image'], guid, config)).then(() =>
            axios
                .patch(`${config.apiGateway.URL}blog/post${apiCode()}`, entity, apiConfig(guid))
                .then(() => {
                    callback?.();
                    dispatch(postLoaded(entity));
                    dispatch(saving(false));
                    dispatch(setShowSuccess('Successfully saved blog post'));
                    dispatch(error(false));
                })
                .catch(err => {
                    // console.log(err);
                    dispatch(error(true));
                    dispatch(saving(false));
                })
        );
    };
};

export const updateComment = (entity, callback) => {
    return (dispatch, getState) => {
        dispatch(saving(true));
        dispatch(error(false));

        const { guid } = getState().user.user;
        return axios
            .patch(`${config.apiGateway.URL}blog/comment${apiCode()}`, entity, apiConfig(guid))
            .then(() => {
                callback?.();
                dispatch(saving(false));
                dispatch(setShowSuccess('Successfully saved comment'));
                dispatch(error(false));
            })
            .catch(() => {
                dispatch(error(true));
                dispatch(saving(false));
            });
    };
};

export const loadPosts = (id, page, sort, ascending, search, competency) => {
    return (dispatch, getState) => {
        dispatch(loading(true));
        dispatch(error(false));
        const { guid } = getState().user.user;
        return axios
            .get(
                `${config.apiGateway.URL}all-blogs${apiCode(true)}id=${id || 0}&page=${page || 1}&search=${
                    search || ''
                }&sort=${sort}&asc=${ascending}&competency=${competency || 0}`,
                apiConfig(guid)
            )
            .then(response => {
                dispatch(postsLoaded(response.data));
            })
            .catch(err => {
                // console.log(err);
                dispatch(error(true));
            })
            .finally(() => {
                dispatch(loading(false));
            });
    };
};

export const loadHomePosts = () => {
    return (dispatch, getState) => {
        dispatch(loading(true));
        dispatch(error(false));
        const { guid } = getState().user.user;
        return axios
            .get(`${config.apiGateway.URL}blog-home${apiCode(true)}`, apiConfig(guid))
            .then(response => {
                dispatch(postsLoaded(response.data));
            })
            .catch(err => {
                // console.log(err);
                dispatch(error(true));
            })
            .finally(() => {
                dispatch(loading(false));
            });
    };
};

export const loadPost = id => {
    return (dispatch, getState) => {
        dispatch(loading(true));
        dispatch(error(false));
        const { guid } = getState().user.user;
        return axios
            .get(`${config.apiGateway.URL}post/${id}${apiCode()}`, apiConfig(guid))
            .then(response => {
                dispatch(postLoaded(response.data));
            })
            .catch(err => {
                // console.log(err);
                dispatch(error(true));
            })
            .finally(() => {
                dispatch(loading(false));
            });
    };
};

export const loadPostFromGuid = postGuid => {
    return (dispatch, getState) => {
        dispatch(loading(true));
        dispatch(error(false));
        const { guid } = getState().user.user;
        return axios
            .get(`${config.apiGateway.URL}post-share/${postGuid}${apiCode()}`, apiConfig(guid))
            .then(response => {
                dispatch(postLoaded(response.data));
            })
            .catch(err => {
                // console.log(err);
                dispatch(error(true));
            })
            .finally(() => {
                dispatch(loading(false));
            });
    };
};

export const updatePostStatus = (post, callback) => {
    return (dispatch, getState) => {
        dispatch(loading(true));
        dispatch(error(false));
        const { guid } = getState().user.user;
        return axios
            .patch(`${config.apiGateway.URL}poststatus${apiCode()}`, post, apiConfig(guid))
            .then(response => {
                callback?.();
            })
            .catch(err => {
                // console.log(err);
                dispatch(error(true));
            })
            .finally(() => {
                dispatch(loading(false));
            });
    };
};

export const deletePost = (post, callback) => {
    return (dispatch, getState) => {
        const { guid } = getState().user.user;
        return axios
            .delete(`${config.apiGateway.URL}post/${post.id}${apiCode()}`, apiConfig(guid))
            .then(response => {
                //dispatch(setShowSuccess('Successfully deleted blog post'));
                callback?.();
            })
            .catch(err => {
                // console.log(err);
            });
    };
};

export const deleteComment = (comment, callback) => {
    return (dispatch, getState) => {
        comment.deleted = true;
        const { guid } = getState().user.user;
        return axios
            .patch(`${config.apiGateway.URL}blog/comment${apiCode()}`, comment, apiConfig(guid))
            .then(response => {
                //dispatch(setShowSuccess('Successfully deleted comment'));
                callback?.();
            })
            .catch(err => {
                // console.log(err);
            });
    };
};
